

































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import { CompanyUserDto } from '@/dto/company-user/company-user.dto';
import companyUserService from '@/services/company-user.service';
import CardWithTitle from '@/modules/_common/components/CardWithTitle.vue';
import InfoChangeDialog from '@/modules/my-page/components/InfoChangeDialog.vue';
import PasswordChangeDialog from '@/modules/my-page/components/PasswordChangeDialog.vue';
import { BaseUser } from '@/services/shared/auth';
import { COMPANY_USER, CONST_COMPANY_USER } from '@/services/shared';

import { getColor } from '@/modules/_common/utils/getColor';

@Component({
  name: 'MyPage',
  components: { CardWithTitle, InfoChangeDialog, PasswordChangeDialog },
})
export default class Mypage extends BaseComponent {
  private companyUserDto = new CompanyUserDto(BaseUser);
  private infoChangeDialog = false;
  private passwordChangeDialog = false;
  private companyUserAdminRole: COMPANY_USER[] = [...CONST_COMPANY_USER];

  getColor(status) {
    return getColor(status);
  }

  getUser() {
    companyUserService.findMe().subscribe(res => {
      this.companyUserDto = res.data;
    });
  }

  created() {
    this.getUser();
  }
}
